import { Component, Input } from '@angular/core'
import { EbProductService } from '../../features/product/services/facades/eb-product.service'

@Component({
    selector: 'eb-document-link',
    templateUrl: './eb-document-link.component.html',
    styleUrls: ['./eb-document-link.component.scss'],
    standalone: false
})
export class EbDocumentLinkComponent {
  @Input() icon
  @Input() title
  @Input() document
  @Input() disabled: boolean
  @Input() disabledHintToken: string

  constructor(private readonly ebProductService: EbProductService) {}

  downloadDocument(mediaCode: string) {
    this.ebProductService.downloadDocument(mediaCode)
  }
}
